import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL;

// A plain <video src="..."> can't carry the Authorization header the
// protected /api/recruitment/videos/:filename endpoint requires, so we fetch
// it as a blob via authenticated axios (global Authorization header already
// set on login) and hand the player an object URL instead.
function VideoPlayer({ videoUrl }) {
  const [objectUrl, setObjectUrl] = useState(null);
  const [error, setError] = useState(false);
  const filename = videoUrl?.split('/').pop();

  useEffect(() => {
    if (!filename) return;
    let currentUrl;
    axios
      .get(`${API_URL}/api/recruitment/videos/${filename}`, { responseType: 'blob' })
      .then((res) => {
        currentUrl = URL.createObjectURL(res.data);
        setObjectUrl(currentUrl);
      })
      .catch(() => setError(true));
    return () => { if (currentUrl) URL.revokeObjectURL(currentUrl); };
  }, [filename]);

  if (error) return <p className="text-xs text-red-500">Video failed to load</p>;
  if (!objectUrl) return <p className="text-xs text-gray-400">Loading video...</p>;

  return (
    <video controls src={objectUrl} className="w-full max-w-sm rounded-lg bg-black" />
  );
}

export default VideoPlayer;
